var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { object, string } from 'yup';
import { investLand } from 'services/clients/api/project';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import PhoneInput from 'components/library/PhoneInput';
import styles from '../../Popup.module.css';
import { addLog, logError } from 'utils/logs';
export default function PopupFormPhone(_a) {
    var _this = this;
    var onNext = _a.onNext, email = _a.email, firstName = _a.firstName, lastName = _a.lastName, project = _a.project;
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), isError = _c[0], setIsError = _c[1];
    var t = useTranslation().t;
    var schema = object().shape({
        phone: string().phone(t('form.validation.phone_invalid')).required(t('form.validation.phone_required')),
    }).required();
    var _d = useForm({
        defaultValues: {
            phone: '+33',
            phoneCountry: 'FR',
        },
        resolver: yupResolver(schema),
    }), control = _d.control, setValue = _d.setValue, handleSubmit = _d.handleSubmit, errors = _d.formState.errors;
    var onSubmit = function (data) { return __awaiter(_this, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    setIsError(false);
                    addLog("Click - PopupFormPhone");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, investLand(__assign(__assign({}, data), { phone_country: data.phoneCountry, email: email, firstName: firstName || undefined, lastName: lastName || undefined, source: 'document', step: 2, ayomi_id: project.id }))];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, onNext(data)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    err_1 = _a.sent();
                    logError(err_1);
                    setIsError(true);
                    return [3 /*break*/, 6];
                case 5:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [(isError) && (_jsxs("p", { className: "error-message", children: [_jsx(FontAwesomeIcon, { icon: "circle-exclamation" }), t("error.request")] })), _jsx(Controller, { name: "phone", control: control, render: function (_a) {
                    var _b;
                    var field = _a.field;
                    return (_jsx(PhoneInput, __assign({}, field, { onCountryChange: function (country) { return setValue('phoneCountry', country); }, label: t("form.phone"), error: (_b = errors.phone) === null || _b === void 0 ? void 0 : _b.message })));
                } }), _jsx("button", { type: "button", "data-transaction-name": "PopupFormPhone", className: styles.submit, onClick: handleSubmit(onSubmit), disabled: isLoading, children: isLoading
                    ? _jsx("span", { className: "spinner" })
                    : (_jsxs(_Fragment, { children: [t("header.form.submit.2"), _jsx(FontAwesomeIcon, { icon: "arrow-right", className: styles['arrow-icon'] })] })) })] }));
}
